import { render, staticRenderFns } from "./TargetSubstance.vue?vue&type=template&id=6632430d&"
import script from "./TargetSubstance.vue?vue&type=script&lang=js&"
export * from "./TargetSubstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports